import { NavLink } from "react-router-dom";
import {
  Home,
  LayoutDashboard,
  ShoppingCart,
  Users,
  User,
  Image,
  CalendarDays,
  TrendingUp,
  Tag,
  Sparkles,
  X,
} from "lucide-react";
import { InstaPassLogo } from "../../Components/layout/Components/InstaPassLogo";

const menuItems = [
  { icon: Home, label: "Home", type: "link", to: "/" },
  { icon: LayoutDashboard, label: "Dashboard", activeIndex: 0 },
  { icon: ShoppingCart, label: "Orders", activeIndex: 1 },
  { icon: Users, label: "Customers", activeIndex: 2 },
  { icon: User, label: "Profile", activeIndex: 3 },
  { icon: Image, label: "Banner", activeIndex: 5 },
  { icon: TrendingUp, label: "Trending Events", activeIndex: 7 },
  { icon: CalendarDays, label: "Latest Events", activeIndex: 6 },
  { icon: CalendarDays, label: "Community Events", activeIndex: 11 },
  { icon: Tag, label: "Create CouponCode", activeIndex: 8 },
  { icon: CalendarDays, label: "User Created Events", activeIndex: 12 },
  { icon: Sparkles, label: "Creator Partners", type: "link", to: "/admin/creators" },
];

function navItemClass(isActive) {
  return `flex items-center gap-3 px-3 py-2.5 rounded-lg text-[13px] transition-all duration-150 mb-0.5 w-full ${
    isActive
      ? "text-white bg-[#1a2744]"
      : "text-white/50 hover:text-white hover:bg-[#1a2744]/50"
  }`;
}

export default function AdminSidebar({ active, setActive, setShowSidebar }) {
  const closeMobile = () => setShowSidebar(false);

  const handleTab = (index) => {
    setActive(index);
    closeMobile();
  };

  return (
    <aside
      className="admin-sidebar fixed left-0 top-0 h-screen w-[200px] bg-[#0B1120] border-r border-[#1a2744] flex flex-col z-40"
      style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
    >
      <button
        type="button"
        className="admin-sidebar-close absolute top-3 right-3 text-white/60 hover:text-white lg:hidden"
        onClick={closeMobile}
        aria-label="Close menu"
      >
        <X className="w-5 h-5" strokeWidth={1.8} />
      </button>

      <nav className="flex-1 pt-5 px-2 overflow-y-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;

          if (item.type === "link") {
            return (
              <NavLink
                key={item.label}
                to={item.to}
                onClick={closeMobile}
                className={({ isActive: routeActive }) =>
                  navItemClass(routeActive)
                }
                style={({ isActive: routeActive }) => ({
                  fontWeight: routeActive ? 600 : 400,
                })}
              >
                {({ isActive: routeActive }) => (
                  <>
                    <Icon
                      className={`w-4 h-4 shrink-0 ${
                        routeActive ? "text-white" : "text-white/40"
                      }`}
                      strokeWidth={1.8}
                    />
                    {item.label}
                  </>
                )}
              </NavLink>
            );
          }

          const isActive = active === item.activeIndex;
          return (
            <button
              key={item.label}
              type="button"
              onClick={() => handleTab(item.activeIndex)}
              className={navItemClass(isActive)}
              style={{ fontWeight: isActive ? 600 : 400 }}
            >
              <Icon
                className={`w-4 h-4 shrink-0 ${
                  isActive ? "text-white" : "text-white/40"
                }`}
                strokeWidth={1.8}
              />
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="px-4 py-6">
        <InstaPassLogo size="lg" />
      </div>
    </aside>
  );
}
